import { FaGithubAlt } from 'react-icons/fa'
import { VscHome, VscMail } from 'react-icons/vsc'

export interface ProfileLinkItem {
  name: string
  url: string
  icon: JSX.Element
}

export const PROFILE_LINK_LIST: ProfileLinkItem[] = [
  { name: 'GitHub', url: 'https://github.com/1000peach', icon: <FaGithubAlt /> },
  { name: 'Gmail', url: 'iam1000peach@gmail.com', icon: <VscMail /> },
  {
    name: 'Portfolio',
    url: 'https://www.notion.so/1000peach/9191128509cd4b089f7a69fceea16f26',
    icon: <VscHome />,
  },
]
